function videoResize(elem, elem_ratio, parent) {
	pRatio = parent.outerWidth()/parent.outerHeight();

	if (pRatio > elem_ratio) {
		// console.log(pRatio + ' cas 1 ' + elem_ratio);
        elem.width("100%");
        elem.height("auto");
    } else {
    	// console.log(pRatio + ' cas 2 ' + elem_ratio);
        elem.width("auto");
        elem.height("100%");
    }

    if (!bgVideoInit) {
        elem.fadeIn(1000);
        bgVideoInit = true;
    }
}

(function ( $ ) {
    $.fn.videoBg = function() {
    	var that = $(this),
		    vRatio = that.width()/that.height(),
		    $parent = that.parent();

	    videoResize(that, vRatio, $parent);
	    // console.log(that.width()+' '+that.height());
	    return $window.resize(function(){
	    	videoResize(that, vRatio, $parent);
	    })
	};
}( jQuery ));

function initVideo() {
	minWidth(screenMd, function(){
		if ($('.js-bg-video').length) {
			
			var video = $('.js-bg-video').find('source');   
        	video.each(function(i){	
		        video[i].src = video[i].getAttribute('data-src');
        	});
		    
			$('.js-bg-video')[0].load();

			$('.js-bg-video').on("canplay", function() {
				$('.js-bg-video').videoBg();
				console.log('canplay');
				// console.log($('.js-bg-video').readyState);
			  	$('.js-bg-video')[0].play();
			});
			if (!bgVideoInit) {
		        $('.js-bg-video').fadeIn(1000);
		        bgVideoInit = true;
		    }
		}
	});
};

function loadVideo() {
	if ($('.js-bg-video').length) {
		$('.js-bg-video')[0].load();
	}
}

$window.on('resize orientationchange', function(e) {
    if ($window.width()!=ww){
    	ww = $window.width();
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {

			initVideo();
		        
		}, 500);    		
    } 
});